import * as React from "react";
import * as ReactDOM from "react-dom";

const $ = (window as any).$;

interface IProps {
	select: HTMLSelectElement,
}

class SelectControl extends React.Component<IProps> {

	constructor(props) {
		super(props);

		this.fieldName = React.createRef();
	}

	fieldName: React.RefObject<HTMLInputElement>;

	componentDidMount() {
		let selectElement = this.props.select;
		if (!selectElement.selectedOptions) {
			// Wsparcie dla IE
			if (selectElement.options[selectElement.selectedIndex]) {
				var x = selectElement.options[selectElement.selectedIndex].text;
				this.fieldName.current.value = x;
			}
		}
		else if (selectElement.selectedOptions[0])
			this.fieldName.current.value = selectElement.selectedOptions[0].innerText;

		$(this.fieldName.current).combobox({
			idControl: $(this.props.select),
			source: (e, ui) => {
				let options = this.props.select.options;
				let result = [];

				let serach = ui.term.toLowerCase();

				for (let i = 0; i < options.length; i++) {
					var option = options[i];
					if (option.innerText.toLowerCase().startsWith(serach)) {
						result.push({
							id: option.value,
							label: option.innerText
						});
					}
				}

				ui.respond(result);
			},
			bCache: false,
			bAllowEmpty: true,
			emptyItem: {
				id: "",
				label: "brak",
			}
		});
	}

	render() {
		return <div>
			<input type="text" ref={this.fieldName} />
		</div>
	}
}

function initSelectCombobox(rootElement: HTMLSelectElement) {
	$(rootElement).hide().addClass("react-working");
	var newDiv = document.createElement('div');
	rootElement.parentNode.insertBefore(newDiv, rootElement.nextSibling);
	var selctControl: any = ReactDOM.render(<SelectControl select={rootElement} />, newDiv);
}

export default {
	initSelectCombobox: initSelectCombobox,
	reload: (rootElement?: HTMLElement) => {
		var selects = (rootElement || document).querySelectorAll("select.react-combobox-control:not(.react-working)");
		if (selects.length != 0) {
			for (let i = 0; i < selects.length; i++) {
				let select = selects[i] as HTMLSelectElement;
				initSelectCombobox(select);
			}
		}
	}
} 